import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey(
  '1c59f6288cca62be9ca7fb3d0a06511cTz0xMjgxNzAsRT0xODA3NzQ3MTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y'
);

export const MuiXLicense = () => null;
